import { all, call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../../../actions/index.types';
import * as req from '../../../../axios/request/SocietyPortal/VisitorReqs/VisitorReqs';

function* getVisitorsList(action) {
    try {
        const result = yield call(req.getVisitorsListReq, action);
        if (result?.success === true) {
            yield put({
                type: types.SOCIETY_GET_VISITORS_LIST_SUCCESS,
                payload: { rows: result.data, pagination: result.meta?.pagination },
            });
        } else {
            yield put({ type: types.SOCIETY_GET_VISITORS_LIST_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_GET_VISITORS_LIST_FAILURE, message: e?.message });
    }
}

function* getVisitorDetails(action) {
    try {
        const result = yield call(req.getVisitorDetailsReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_GET_VISITOR_DETAILS_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.SOCIETY_GET_VISITOR_DETAILS_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_GET_VISITOR_DETAILS_FAILURE, message: e?.message });
    }
}

function* createVisitor(action) {
    try {
        const result = yield call(req.createVisitorReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_CREATE_VISITOR_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_CREATE_VISITOR_FAILURE, message: result?.response?.data?.message });
            action.data?.onError?.(result);
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_CREATE_VISITOR_FAILURE, message: e?.message });
    }
}

function* updateVisitor(action) {
    try {
        const result = yield call(req.updateVisitorReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_UPDATE_VISITOR_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_UPDATE_VISITOR_FAILURE, message: result?.response?.data?.message });
            action.data?.onError?.(result);
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_UPDATE_VISITOR_FAILURE, message: e?.message });
    }
}

function* deleteVisitor(action) {
    try {
        const result = yield call(req.deleteVisitorReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_DELETE_VISITOR_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_DELETE_VISITOR_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_DELETE_VISITOR_FAILURE, message: e?.message });
    }
}

function* blockVisitor(action) {
    try {
        const result = yield call(req.blockVisitorReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_BLOCK_VISITOR_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_BLOCK_VISITOR_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_BLOCK_VISITOR_FAILURE, message: e?.message });
    }
}

function* unblockVisitor(action) {
    try {
        const result = yield call(req.unblockVisitorReq, action);
        if (result?.success === true) {
            yield put({ type: types.SOCIETY_UNBLOCK_VISITOR_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.SOCIETY_UNBLOCK_VISITOR_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.SOCIETY_UNBLOCK_VISITOR_FAILURE, message: e?.message });
    }
}

// No /api/visitors/stats exists, so the banner's counters come from two cheap
// list probes (limit=1) read off meta.pagination.total. Active is the
// difference rather than a third call.
function* getVisitorSummary(action) {
    try {
        const societyId = action.data?.societyId;
        if (!societyId) return;
        const [totalRes, blockedRes] = yield all([
            call(req.getVisitorCountReq, societyId),
            call(req.getVisitorCountReq, societyId, { is_blocked: 'true' }),
        ]);
        const total = totalRes?.meta?.pagination?.total;
        const blocked = blockedRes?.meta?.pagination?.total;
        if (typeof total !== 'number') {
            yield put({ type: types.SOCIETY_GET_VISITOR_SUMMARY_FAILURE });
            return;
        }
        const blockedCount = typeof blocked === 'number' ? blocked : 0;
        yield put({
            type: types.SOCIETY_GET_VISITOR_SUMMARY_SUCCESS,
            payload: { total, blocked: blockedCount, active: Math.max(total - blockedCount, 0) },
        });
    } catch (e) {
        yield put({ type: types.SOCIETY_GET_VISITOR_SUMMARY_FAILURE, message: e?.message });
    }
}

export default function* VisitorSaga() {
    yield takeLatest(types.SOCIETY_GET_VISITORS_LIST, getVisitorsList);
    yield takeLatest(types.SOCIETY_GET_VISITOR_DETAILS, getVisitorDetails);
    yield takeLatest(types.SOCIETY_CREATE_VISITOR, createVisitor);
    yield takeLatest(types.SOCIETY_UPDATE_VISITOR, updateVisitor);
    yield takeLatest(types.SOCIETY_DELETE_VISITOR, deleteVisitor);
    yield takeLatest(types.SOCIETY_BLOCK_VISITOR, blockVisitor);
    yield takeLatest(types.SOCIETY_UNBLOCK_VISITOR, unblockVisitor);
    yield takeLatest(types.SOCIETY_GET_VISITOR_SUMMARY, getVisitorSummary);
}
